import LexicalComposerContext from "@lexical/react/LexicalComposerContext"
import {useLayoutEffect} from "react"
import type {EditorState, LexicalEditor} from "lexical"
import type {NodeKey} from "lexical/LexicalNode"

type IntentionallyMarkedAsDirtyElement = boolean;

type Props = {
    ignoreHistoryMergeTagChange?: boolean
    ignoreSelectionChange?      : boolean
    onChange?                   : {(data: {
            prevEditorState     : EditorState,
            editorState         : EditorState,
            editor              : LexicalEditor,
            dirtyElements       : Map<NodeKey, IntentionallyMarkedAsDirtyElement>,
            dirtyLeaves         : Set<NodeKey>,
            normalizedNodes     : Set<NodeKey>,
            tags                : Set<string>
        }):void}
}

const debug = false
// const debug = "OnChangePlugin"

export default function OnChangePlugin(props:Props) {

    const {
        ignoreHistoryMergeTagChange = true,
        ignoreSelectionChange       = false,
    } = props

    const [editor] = LexicalComposerContext.useLexicalComposerContext();
    useLayoutEffect(() => {
        if (props.onChange) {
            return editor.registerUpdateListener(({
                                                      editorState,
                                                      dirtyElements,
                                                      dirtyLeaves,
                                                      prevEditorState,
                                                      normalizedNodes,
                                                      tags
                                                  }) => {

                const selectionOnlyChange   = ignoreSelectionChange && dirtyElements.size === 0 && dirtyLeaves.size === 0
                const historyMergeChange    = ignoreHistoryMergeTagChange && tags.has('history-merge')
                const wasEmpty              = prevEditorState.isEmpty()
                const nothingChanged        = _.isEqual(prevEditorState.toJSON(), editorState.toJSON())

                debug && console.log(debug, 'update', selectionOnlyChange, historyMergeChange, wasEmpty, nothingChanged)

                if (selectionOnlyChange || historyMergeChange || wasEmpty || nothingChanged) {
                    return
                }

                props.onChange && props.onChange({
                    prevEditorState,
                    editorState,
                    editor,
                    dirtyElements,
                    dirtyLeaves,
                    normalizedNodes,
                    tags
                });
            });
        }
    }, [editor, props.ignoreHistoryMergeTagChange, props.ignoreSelectionChange, props.onChange])
    return null
}